import _ from 'lodash'

/**
 * Returns true if all currently selected blocks in ribbon match all the blocks in configuration of the report type item (admin, credit, etc.).
 * Otherwise returns false.
 * @param {array} selectedBlocks Array of blocks (objects) that are currently selected in ribbon
 * @param {array} itemBlocks Array of blocks (objects) from currenctly selected report type (admin, credit, etc.) configuration
 * @returns Boolean
 */

export const isSelectedByBlocks = (selectedBlocks, itemBlocks) => {
    // eslint-disable-line import/prefer-default-export
    const filteredItemBlocks = _.filter(itemBlocks, (b) => !_.get(b, 'isDisabled', false)) // Filter out blocks that are disabled

    return _.every(filteredItemBlocks, (block) => _.get(selectedBlocks, `${_.get(block, 'name')}`, false))
}
